<template>
  <el-dialog
    :title="$t('announcement.title')"
    :visible.sync="visible"
    width="480px"
    top="0"
    append-to-body
    custom-class="zj-announcement-dialog"
    :close-on-click-modal="false"
  >
    <div class="announcement-dialog__body">{{ content }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">{{ $t('announcement.ok') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
function apiUrl(path) {
  const root = (process.env.VUE_APP_API_BASE || '').replace(/\/$/, '')
  const p = path.startsWith('/') ? path : `/${path}`
  return root ? `${root}${p}` : p
}

export default {
  name: 'AnnouncementDialog',
  data() {
    return {
      visible: false,
      content: '',
      loading: false
    }
  },
  mounted() {
    this.loadAndShow()
  },
  methods: {
    async loadAndShow() {
      if (this.loading) return
      this.loading = true
      try {
        const res = await fetch(apiUrl('/api/site/popup-announcement'))
        const data = await res.json().catch(() => ({}))
        if (!data || !data.ok || !data.enabled) return
        const text = data.content != null ? String(data.content) : ''
        if (!text.trim()) return
        this.content = text
        this.visible = true
      } catch (e) {
        // 公告失败不打扰正常浏览
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
/* append-to-body：需非 scoped，才能作用到挂到 body 的弹窗 */
.el-dialog__wrapper:has(.zj-announcement-dialog) {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.el-dialog__wrapper:has(.zj-announcement-dialog) .zj-announcement-dialog.el-dialog {
  margin: 0 !important;
  position: relative;
  top: auto;
  transform: none;
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  box-shadow: 0 28px 80px rgba(16, 42, 50, 0.18);
}

.zj-announcement-dialog .el-dialog__body {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 0;
  overflow-y: auto;
}

@media (max-width: 520px) {
  .el-dialog__wrapper:has(.zj-announcement-dialog) .zj-announcement-dialog.el-dialog {
    width: calc(100% - 28px) !important;
  }
}
</style>

<style scoped>
.announcement-dialog__body {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.7;
  font-size: 14px;
  color: #0f172a;
  max-height: 50vh;
  overflow-y: auto;
}
</style>
